import { HttpService } from "../http";

export class MemberDetailsService extends HttpService {
  fetchMemberDetails = async (id: number, payload?: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/course-taker/stats/${id}`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchMemberHistory = async (id: number, payload?: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/course-taker/journalist/${id}`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
